/* Candidate integration: no request on load; server-side rules remain mandatory. */
(function () {
  'use strict';
  let activeRoot = null;
  function initialize(root) {
    if (root.dataset.purchaseInitialized === 'true' || root.dataset.enableCart !== 'true') return;
    const catalog = window.PL8WholesaleCatalog?.read(root);
    if (!catalog || root.dataset.initialized !== 'true') return;
    const one = selector => root.querySelector(selector);
    const all = selector => Array.from(root.querySelectorAll(selector));
    const status = one('[data-cart-status]');
    const words = JSON.parse(one('[data-pl8-words]').textContent);
    const message = key => words[key] || words.cart_unavailable;
    if (activeRoot && activeRoot !== root) { status.textContent = message('cart_config'); return; }
    const qty = all('[data-qty]');
    const business = one('[data-business]'), accepted = one('[data-accept]');
    const add = one('[data-cart-add]'), recheck = one('[data-cart-recheck]'), checkout = one('[data-cart-checkout]');
    const verification = one('[data-cart-verification]'), dialog = one('[data-review-dialog]');
    const money = value => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 }).format(value);
    let busy = false, verified = false, reviewed = null, adapter;
    const messages = {
      CART_NOT_EMPTY: 'cart_existing', EXISTING_WHOLESALE: 'cart_existing_wholesale',
      PRICE_MISMATCH: 'cart_price', ADD_REJECTED: 'cart_rejected',
      ADD_UNCONFIRMED: 'cart_unknown', CART_UNCONFIRMED: 'cart_unknown',
      CART_MISMATCH: 'cart_mismatch', METADATA_MISMATCH: 'cart_mismatch',
      RECOVERY_REQUIRED: 'cart_retry_forbidden'
    };
    function show(key, error = false) {
      status.textContent = message(key);
      status.dataset.error = String(error);
    }
    try {
      adapter = window.PL8WholesaleCart.createAdapter({ catalog, routesRoot: window.Shopify.routes.root, enabled: true, fetchImpl: window.fetch.bind(window) });
    } catch (_) { show('cart_config', true); return; }
    activeRoot = root;
    root.dataset.purchaseInitialized = 'true';
    one('[data-cart-actions]').hidden = false;
    // This href is locale-aware and never changes or empties a cart.
    one('[data-cart-view]').href = window.Shopify.routes.root + 'cart';
    function selection() {
      return {
        selections: catalog.map((record, index) => ({ variantId: record.variantId, wholesaleSku: record.wholesaleSku, retailSku: record.retailSku, quantity: qty[index].value })),
        businessName: business.value, businessAccepted: accepted.checked
      };
    }
    function snapshot() { return JSON.stringify(selection()); }
    function update() {
      const locked = busy || adapter.status.postAttempted;
      [...qty, business, accepted, ...all('[data-plus], [data-minus], [data-reset], [data-confirm-reset]')].forEach(input => {
        if (locked) input.disabled = true;
        else if (input.matches('[data-qty], [data-business], [data-accept], [data-reset], [data-confirm-reset]')) input.disabled = false;
        else {
          const index = Number(input.dataset.plus ?? input.dataset.minus);
          const parsed = window.PL8WholesaleCore.parseQuantity(qty[index].value);
          input.disabled = !parsed.valid || (input.hasAttribute('data-plus') ? parsed.value >= 50 : parsed.value === 0);
        }
      });
      add.disabled = busy || !adapter.status.canSubmit || reviewed === null || !dialog.open;
      recheck.disabled = busy || !adapter.status.postAttempted;
      checkout.disabled = busy || !verified || !adapter.status.canCheckout;
    }
    function invalidate(changed = false) {
      verified = false; verification.hidden = true;
      if (changed) reviewed = null;
      if (adapter.status.postAttempted) show('cart_stale');
      update();
    }
    function success(result) {
      verified = true;
      show('cart_verified');
      verification.textContent = result.cart.items.map(item => item.sku + ' / ' + message('cart_printing_sku') + ' ' + item.properties.printingSku + ' / ' + item.quantity + words.pieces).join('\n') + '\n' + words.total_label + ' ' + result.cart.item_count + words.pieces + ' / ' + money(result.cart.total_price / 100);
      verification.hidden = false;
    }
    async function perform(action, navigate = false) {
      if (busy) return;
      busy = true; verified = false; update(); show('cart_busy');
      try {
        const result = await action();
        success(result);
        // Navigation happens only after a separate checkout click and fresh GET.
        if (navigate) window.location.assign(result.checkoutPath);
      } catch (error) {
        verified = false; verification.hidden = true;
        show(messages[error.code] || 'cart_unavailable', true);
        status.focus();
      } finally { busy = false; update(); }
    }
    one('[data-review]').addEventListener('click', () => {
      if (dialog.open && !adapter.status.postAttempted) reviewed = snapshot();
      update();
    });
    root.addEventListener('pl8:selectionchange', () => invalidate(true));
    business.addEventListener('input', () => invalidate(true));
    accepted.addEventListener('change', () => invalidate(true));
    dialog.addEventListener('close', update);
    add.addEventListener('click', () => {
      if (add.disabled) return;
      if (reviewed !== snapshot()) { reviewed = null; show('cart_mismatch', true); update(); return; }
      const input = selection();
      perform(() => adapter.submit(input));
    });
    recheck.addEventListener('click', () => { if (!recheck.disabled) perform(() => adapter.reconcile()); });
    checkout.addEventListener('click', () => { if (!checkout.disabled) perform(() => adapter.reconcile(), true); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) invalidate(); });
    window.addEventListener('pageshow', event => { if (event.persisted) invalidate(); });
    window.addEventListener('focus', () => { if (adapter.status.postAttempted && !busy) invalidate(); });
    update();
  }
  function boot(scope) {
    if (scope.matches?.('[data-pl8-wholesale]')) initialize(scope);
    scope.querySelectorAll('[data-pl8-wholesale]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
